/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function getStyleValue(variable) {
  const root = document.querySelector(':root');
  let computedStyleRoot = getComputedStyle(root);
  let value = computedStyleRoot.getPropertyValue(variable);
  return value;
}
function setStyleValue(variable, value) {
  const root = document.querySelector(':root');
  root.style.setProperty(variable, value);
}
function getOuterHeight(el) {
  let $el = typeof el === 'string' ? document.querySelector(el) : el;
  let height = $el.clientHeight;
  height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-top'));
  height += parseInt(window.getComputedStyle($el).getPropertyValue('margin-bottom'));
  return height;
}
function scrollYY() {
  if( window.pageYOffset ) { return window.pageYOffset; }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('template-index')) {
    let navHeight = document.querySelector('.template-index .theme__header')?.clientHeight;
    let videoHeight = document.querySelector('.template-index .index-hero .video-background')?.clientHeight;
    let navOffset = videoHeight - navHeight;
    const SIZES = {
      logoMobile: 40.37,
      logoDesktop: 40.37, 
    }
    const SELECTORS = {
      mastheadHero: '.index-hero',
      mastheadLogo: '.index-hero-logo svg',
      themeHeader: '.theme__header',
      logoMobile: '.header__mobile .logo__img--transparent',
      logoDesktop: '.header__desktop .logo__img--transparent', 
    }
    const $el = {
      mastheadHero: document.querySelector(SELECTORS.mastheadHero),
      mastheadLogo: document.querySelector(SELECTORS.mastheadLogo),
      themeHeader: document.querySelector(SELECTORS.themeHeader),
      logoMobile: document.querySelector(SELECTORS.logoMobile),
      logoDesktop: document.querySelector(SELECTORS.logoDesktop),
    }
    
    let themeHeaderHeight = getOuterHeight($el.themeHeader);
    let mastheadHeroHeight = getOuterHeight($el.mastheadHero);
    let mastheadInitialHeight = getOuterHeight($el.mastheadLogo);
    setStyleValue('--masthead-height', `${mastheadInitialHeight}px`);
    
    $el.mastheadLogo.style.height = mastheadInitialHeight;
    $el.mastheadLogo?.classList?.remove('init');
    
    window.addEventListener('resize', function () {
      setStyleValue('--masthead-height', `${getOuterHeight($el.mastheadLogo)}px`);
      mastheadInitialHeight = getOuterHeight($el.mastheadLogo);
    });
    
    document.addEventListener('scroll', function() {
      let currentLogoSize;
      let currentProgress;
      if (window.innerWidth < 750) {
        currentProgress = (1 - (scrollYY() / (mastheadHeroHeight - (themeHeaderHeight + 32)) ))
        currentLogoSize = currentProgress * mastheadInitialHeight;
        if (currentLogoSize > SIZES.logoMobile) {
          $el.mastheadLogo.style.height = `${currentLogoSize}px`;
        } else {
          $el.mastheadLogo.style.height = `${SIZES.logoMobile}px`;
        }
        if (currentProgress <= 0) {
          $el.mastheadLogo.style.opacity = 0;
          $el.logoMobile.style.opacity = 1;
        } else {
          $el.mastheadLogo.style.opacity = 1;
          $el.logoMobile.style.opacity = 0;
        }
      } else {
        currentProgress = (1 - (scrollYY() / (mastheadHeroHeight - (themeHeaderHeight * 2 + 40)) ))
        currentLogoSize = currentProgress * mastheadInitialHeight;
        console.log(currentProgress)
        if (currentLogoSize > SIZES.logoDesktop) {
          $el.mastheadLogo.style.height = `${currentLogoSize}px`;
        } else {
          $el.mastheadLogo.style.height = `${SIZES.logoDesktop}px`;
        }
        if (currentProgress <= 0) {
          $el.mastheadLogo.style.opacity = 0;
          $el.logoDesktop.style.opacity = 1;
        } else {
          $el.mastheadLogo.style.opacity = 1;
          $el.logoDesktop.style.opacity = 0;
        }
      }
    }); 
  }  
});

// /////////////////////////////////////////////////////////////////////////////////
// DISPLAY SET PRODUCTS ////////////////////////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////
                          
if (document.body.classList.contains('template-product')) {
	const productSet = window.productSet;
	const currentProduct = document.querySelector('.product-set-thumbs').dataset.product;
	
	if (productSet !== null && productSet !== undefined && productSet?.enable && productSet?.products.length > 0) {
		//console.log(productSet);
		//document.querySelector('ul.product-set-products').innerHTML = '';
		
		if (productSet?.title && productSet?.title !== '') {
			const titleElement = document.createElement('h5');
			titleElement.className = 'section-title';
			titleElement.textContent = productSet.title;
			document.querySelector('.product-set-thumbs').prepend(titleElement);
		}
		
		for (let i = 0; i < productSet?.products.length; i++) {
			if (productSet?.products[i].handle !== '') {
				const listItem = document.createElement('li');
				if (productSet?.products[i].handle === currentProduct) {
					listItem.className = 'current';
				}
				
				const link = document.createElement('a');
				link.className = 'product-set-product';
				link.href = productSet.products[i].url;
				
				const image = document.createElement('img');
				image.className = 'product-image';
				image.src = productSet.products[i].image;
				image.alt = productSet.products[i].title;
				
				const title = document.createElement('h6');
				title.className = 'product-title';
				title.textContent = productSet.products[i].title;
				
				link.appendChild(image);
				link.appendChild(title);
				listItem.appendChild(link);
				
				document.querySelector('ul.product-set-products').appendChild(listItem);
			}
		}
		document.querySelector('section.product-set-thumbs').classList.remove('init');
	} else {
		document.querySelector('section.product-set-thumbs').remove();
	}
}
